import React, { useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import Sidebar from "./sidebar";
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { ClockIcon, MenuIcon } from "../assets/icons/svgs";

import { JandiLogo } from "@/components/assets/logos/svgs";
import { Link, Navigate, useLocation, useSearchParams } from "react-router-dom";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
// import HeaderNavContent from "@/header/HeaderNavContent";
import { logoutUser } from "@/features/user/userSlice";
import { RootState } from "@/store/store";
import Popup from "@/shared/popups/popupDetails";
import Login from "@/pages/auth/login/index";
import Register from "@/pages/auth/register";
import ForgotPassword from "@/pages/auth/forgotPassword";
import VerifyAccount from "@/pages/auth/verify-account";
import ResetPassword from "@/pages/auth/resetPassword";
import AvatarDropdown from "@/shared/AvatarDropdown";
import { Logout } from "@/shared/services/credentialsService";
import AvatarShellDropdown from "@/shared/AvatarShellDropdown";

const SIDEBAR_WIDTH = 280;
const APPBAR_HEIGHT = 78;

const ShellContainer = () => {
    const navigate = useNavigate();
    // Responsive sidebar state
    const [sidebarOpen, setSidebarOpen] = useState(window.innerWidth > 768);
    const [sidebarVariant, setSidebarVariant] = useState(window.innerWidth > 768 ? 'permanent' : 'temporary');
    const { user, token } = useSelector((state: RootState) => state.user);
    const isWorker = user.type === "worker";
    const dispatch = useDispatch();
    // Responsive sidebar logic
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth <= 768) {
                setSidebarVariant('temporary');
                setSidebarOpen(false);
            } else {
                setSidebarVariant('permanent');
                setSidebarOpen(true);
            }
        };
        window.addEventListener('resize', handleResize);
        // Initial check
        handleResize();
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // Only toggle sidebar on menu icon click
    const handleToggleSidebar = () => setSidebarOpen((prev) => !prev);

    return (
        <Box sx={{ display: 'flex', minHeight: '100vh', bgcolor: 'black' }}>
            {/* Responsive sidebar */}
            <Sidebar open={sidebarOpen} setOpen={setSidebarOpen} variant={sidebarVariant} width={SIDEBAR_WIDTH} />
            <AppBar
                position="fixed"
                sx={{
                    bgcolor: 'white',
                    boxShadow: 0,
                    width: sidebarVariant === 'permanent' && sidebarOpen ? `calc(100% - ${SIDEBAR_WIDTH}px)` : '100%',
                    left: sidebarVariant === 'permanent' && sidebarOpen ? `${SIDEBAR_WIDTH}px` : 0,
                    zIndex: 1202
                }}
            >
                <Toolbar sx={{ display: 'flex', justifyContent: 'space-between', minHeight: APPBAR_HEIGHT, height: APPBAR_HEIGHT }}>
                    <div className="flex items-center gap-0">
                        <IconButton
                            color="inherit"
                            edge="start"
                            onClick={handleToggleSidebar}
                            sx={{ mr: 2, display: { sm: 'block', md: 'block' } }}
                        >
                            <MenuIcon className="w-6 h-6"  />
                        </IconButton>
                        {/* <h1 className="text-2xl font-semibold text-black">Dashboard</h1>  */}
                    </div>
                   <AvatarShellDropdown user={user} onLogout={() => { dispatch(logoutUser()); Logout(); navigate('/'); }} />
                </Toolbar>
            </AppBar>
            <Box
                sx={{
                    flexGrow: 1,
                    minWidth: 0,
                    pt: `${APPBAR_HEIGHT}px`,
                    width: '100%',
                    transition: 'padding-left 0.3s',
                    height: '100vh',
                    bgcolor: '#F3F4F6',
                    display: 'flex',
                    flexDirection: 'column',
                }}
            >
                <Box sx={{ flex: 1, minWidth: 0, width: '100%', height: '100%', bgcolor: '#F3F4F6', display: 'flex', flexDirection: 'column' }}>
                    <Outlet />
                </Box>
            </Box>
        </Box>
    );
};

export default ShellContainer;
